import React, { Fragment, useState } from 'react'

import { Link, useLocation } from 'react-router-dom'
import styled from 'styled-components'

import { useWindowSize, useEventListener } from '../../../_helpers'
import {
    Header,
    ImageCard,
    ArticleTextWrap,
    Block,
    Grid,
    devices,
    SecondaryButton,
    PrimaryButton,
    colors,
} from '../../Common'


const ArticleContent = ({ pageBlock, siblings }) => (
    <Fragment>
        {pageBlock.title && pageBlock.show_title ? (
            <Header margintop={10} fontSize={60} marginbottom={20} unsetmaxwidth>{pageBlock.title}</Header>
        ) : ''}
        {pageBlock.image ? (
            <ImageCard background={pageBlock.image} alt={pageBlock.alt_text} height={540} marginbottom={20} />
        ) : ''}
        <ArticleTextWrap
            shorten={!siblings}
            nopadding={pageBlock.type === 'SIDEBAR'}
            dangerouslySetInnerHTML={{ __html: pageBlock.content }}
        />
        {pageBlock.link_text ? (
            <PrimaryButton
                as={pageBlock.linked_page ? Link : 'a'}
                to={pageBlock.linked_page ? pageBlock.linked_page : ''}
                href={pageBlock.external_url}
                target={pageBlock.external_url ? '_blank' : undefined}
                rel={pageBlock.external_url ? 'noopener noreferrer' : ''}
                style={{ width: 'auto' }}
                margintop={30}
            >
                {pageBlock.link_text}
            </PrimaryButton>
        ) : ''}
    </Fragment>
)

const BlockComp = ({ pageBlock, id, textPadding, columns }) => {
    const { width } = useWindowSize()
    const location = useLocation()
    const calculateHeight = () => {
        let ratio
        const mobile = width < 480
        switch (pageBlock.format) {
            case '3-COLUMN':
                ratio = 7 / 2
                break
            case 'LEFT-IMAGE':
            case 'RIGHT-IMAGE':
                ratio = 7 / 3
                break
            default:
                ratio = 6 / 4
        }
        const newWidth = width / (mobile ? 1 : 2)
        return newWidth / ratio
    }

    const [imageHeight, setImageHeight] = useState(calculateHeight())

    const updateHeight = () => setImageHeight(Math.round(calculateHeight()))

    const showTitle = pageBlock[`title${id}`] && pageBlock[`title${id}`] !== 'None' && ((pageBlock.format === '3-COLUMN' && pageBlock.title2) || pageBlock.format !== '3-COLUMN') || (pageBlock.format === 'LEFT-IMAGE' && id === '2')
    const title = pageBlock.format === 'LEFT-IMAGE' ? id === '2' ? pageBlock.title : '' : pageBlock[`title${id}`]

    useEventListener('resize', updateHeight)
    return (
        <FlexColumn
            key={`#${id}`}
            marginright={Number(id) === columns ? 0 : 30}
            nomargin={location.pathname === '/about/board/'}
            center={pageBlock.format === '3-COLUMN' && pageBlock[`link_text${id}`]}
        >
            {pageBlock[`image${id}`] &&
                <ImageCard background={pageBlock[`image${id}`]} margintop={pageBlock.format === '3-COLUMN' ? 30 : 0} height={imageHeight} alt={pageBlock[`alt_text${id}`]} />
            }
            <TextContent paddingRight={textPadding} center={pageBlock.format === '3-COLUMN' && pageBlock[`link_text${id}`]}>
                {pageBlock.show_title && showTitle &&
                    <Header>
                        {title}
                    </Header>
                }
                {pageBlock[`content${id}`] &&
                    <Block
                        paddingbottom={location.pathname !== '/about/board/' ? 20 : 0}
                        paddingtop={pageBlock.format === '3-COLUMN' && location.pathname !== '/about/board/' ? 30 : 0}
                        dangerouslySetInnerHTML={{ __html: pageBlock[`content${id}`] }}
                        anchorcolor={colors.darkGreen}
                        center={pageBlock.format === '3-COLUMN' && pageBlock.title2}
                    />
                }
                {pageBlock[`link_text${id}`] ? pageBlock.format === '3-COLUMN' ? (
                    <PrimaryButton
                        as={pageBlock[`linked_page${id}`] ? Link : 'a'}
                        to={pageBlock[`linked_page${id}`] ? pageBlock[`linked_page${id}`] : ''}
                        href={pageBlock[`external_url`]}
                        style={{ width: '240px' }}
                    >
                        {pageBlock[`link_text${id}`]}
                    </PrimaryButton>
                ) : (
                        <SecondaryButton
                            as={pageBlock[`linked_page${id}`] ? Link : 'a'}
                            to={pageBlock[`linked_page${id}`] ? pageBlock[`linked_page${id}`] : ''}
                            href={pageBlock[`external_url`]}
                            style={{ width: '220px' }}
                        >
                            {pageBlock[`link_text${id}`]}
                        </SecondaryButton>
                    ) : ''}
            </TextContent>
        </FlexColumn>
    )
}

export const SimpleBlock = props => props.columns === 1 ? <ArticleContent {...props} /> : <BlockComp {...props} />

const FlexColumn = styled(Grid.Column)`
    display: flex;
    flex-direction: column;
    text-decoration: none;
    color: inherit;
    ${({ center }) => center ? 'align-items: center;' : ''}
    margin-right: ${props => props.marginright}px;
    @media ${devices.mobile} {
        margin-right: 0;
        margin-bottom: ${props => props.nomargin ? '0' : '30px'};
    }
`

const TextContent = styled.article`
    padding-right: ${({ paddingRight = '2rem' }) => paddingRight};
    height: 100%;
    ${({ center }) => center ? 'align-items: center;' : ''}
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .before-top {
        margin-bottom: auto;
    }
`
